import { render } from "./px-questionary.vue?vue&type=template&id=03f270ad&scoped=true&ts=true"
import script from "./px-questionary.vue?vue&type=script&lang=ts"
export * from "./px-questionary.vue?vue&type=script&lang=ts"

import "./px-questionary.vue?vue&type=style&index=0&id=03f270ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f270ad"]])

export default __exports__